(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Find the Shopify section wrapper (parent element with ID starting with 'shopify-section-')
      this.header = this.closest('[id^="shopify-section-"]') || this.parentElement?.closest('[id^="shopify-section-"]') || document.querySelector('[id^="shopify-section-header"]');
      
      // Fallback: if section wrapper not found, use the sticky-header element itself
      if (!this.header) {
        this.header = this;
      }
      
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;
      
      let observer = new IntersectionObserver((entries, observer) => {
        if (entries[0]) {
          this.headerBounds = entries[0].intersectionRect;
        }
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.header) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.header) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      if (!this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  // Preserve custom cart icon image and refresh cart count when cart updates
  (function() {
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (!cartIconBubble) return;

    const iconImageSrc = 'https://cdn.shopify.com/s/files/1/0783/6595/0176/files/Icon.png?v=1766410443';

    // Function to fetch and update cart count
    async function updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const cartIconContainer = document.getElementById('cart-icon-bubble');
        if (!cartIconContainer) return;

        let cartCount = cartIconContainer.querySelector('.header-cart-count');
        if (cartCount) {
          const itemText = cart.item_count === 1 ? 'item' : 'items';
          cartCount.textContent = `${cart.item_count} ${itemText}`;
        }
      } catch (error) {
        console.log('Cart count update failed:', error);
      }
    }

    // Function to ensure image icon is present and remove all SVG icons
    function preserveCartIcon() {
      const cartIconContainer = document.getElementById('cart-icon-bubble');
      if (!cartIconContainer) return;

      // Remove ALL SVG icons from anywhere in the cart icon container
      const allSvgs = cartIconContainer.querySelectorAll('svg, use, symbol');
      allSvgs.forEach(el => el.remove());
      
      // Remove any direct SVG children
      Array.from(cartIconContainer.children).forEach(child => {
        if (child.tagName === 'SVG' || child.querySelector('svg')) {
          child.remove();
        }
      });

      // Find or create icon container
      let iconContainers = cartIconContainer.querySelectorAll('.header-cart-icon');
      
      // If multiple icon containers exist, remove duplicates and keep only the first one
      if (iconContainers.length > 1) {
        for (let i = 1; i < iconContainers.length; i++) {
          iconContainers[i].remove();
        }
      }
      
      let iconContainer = cartIconContainer.querySelector('.header-cart-icon');
      
      // If icon container doesn't exist, create it
      if (!iconContainer) {
        iconContainer = document.createElement('span');
        iconContainer.className = 'header-cart-icon';
        cartIconContainer.insertBefore(iconContainer, cartIconContainer.firstChild);
      }
      
      // Remove any SVG icons from the icon container
      const svgInContainer = iconContainer.querySelectorAll('svg, use, symbol');
      svgInContainer.forEach(el => el.remove());
      
      // Check if image exists
      const existingImg = iconContainer.querySelector('img');
      
      if (!existingImg) {
        // Clear container and add image
        iconContainer.innerHTML = '';
        const img = document.createElement('img');
        img.src = iconImageSrc;
        img.alt = 'Cart';
        img.width = 20;
        img.height = 20;
        img.loading = 'lazy';
        iconContainer.appendChild(img);
      } else {
        // Ensure image src is correct
        existingImg.src = iconImageSrc;
      }
      
      // Ensure cart count element exists
      let cartCount = cartIconContainer.querySelector('.header-cart-count');
      if (!cartCount) {
        cartCount = document.createElement('span');
        cartCount.className = 'header-cart-count';
        // Insert after icon
        if (iconContainer.nextSibling) {
          cartIconContainer.insertBefore(cartCount, iconContainer.nextSibling);
        } else {
          cartIconContainer.appendChild(cartCount);
        }
        // Update count
        updateCartCount();
      }
    }

    // Function to handle cart updates - preserve icon and refresh count
    function handleCartUpdate() {
      preserveCartIcon();
      updateCartCount();
    }

    // Watch for cart updates using MutationObserver - more aggressive
    const observer = new MutationObserver(function(mutations) {
      let shouldPreserve = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // Check added nodes
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if SVG or icon-related elements were added
              if (node.tagName === 'SVG' || node.tagName === 'USE' || node.tagName === 'SYMBOL' || 
                  (node.querySelector && node.querySelector('svg, use, symbol'))) {
                shouldPreserve = true;
              }
              // Check if cart icon structure changed
              if (node.classList && (node.classList.contains('header-cart-icon') || node.classList.contains('header-cart-count'))) {
                shouldPreserve = true;
              }
            }
          });
          // Check removed nodes
          mutation.removedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.classList && node.classList.contains('header-cart-icon')) {
                shouldPreserve = true;
              }
              if (node.tagName === 'SVG' || node.tagName === 'USE') {
                shouldPreserve = true;
              }
            }
          });
        }
        // Also check attribute changes
        if (mutation.type === 'attributes') {
          shouldPreserve = true;
        }
      });
      if (shouldPreserve) {
        // Use requestAnimationFrame for immediate execution
        requestAnimationFrame(function() {
          handleCartUpdate();
        });
      }
    });

    // Start observing the cart icon element
    observer.observe(cartIconBubble, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'id']
    });

    // Listen for various cart update events
    const cartEvents = [
      'cart:updated',
      'cart:refresh',
      'cart:change',
      'cart:add',
      'cart:remove',
      'cart:clear'
    ];
    
    cartEvents.forEach(eventName => {
      document.addEventListener(eventName, handleCartUpdate);
      window.addEventListener(eventName, handleCartUpdate);
    });

    // Listen for cart form submissions (cart page deletions)
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form && form.action && (
        form.action.includes('/cart/change') || 
        form.action.includes('/cart/update') ||
        form.action.includes('/cart/clear')
      )) {
        // Wait a bit for the request to complete
        setTimeout(handleCartUpdate, 500);
      }
    }, true);

    // Also listen for fetch/XHR completion (cart page deletions often use fetch)
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      return originalFetch.apply(this, args).then(response => {
        const url = args[0];
        if (typeof url === 'string' && (
          url.includes('/cart/change.js') || 
          url.includes('/cart/update.js') || 
          url.includes('/cart/clear.js') ||
          url.includes('/cart.js')
        )) {
          setTimeout(handleCartUpdate, 100);
        }
        return response;
      });
    };
    
    // Preserve icon on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        preserveCartIcon();
        updateCartCount();
      });
    } else {
      preserveCartIcon();
      updateCartCount();
    }

    // Periodic check as fallback - check for SVG icons and remove them
    setInterval(function() {
      const cartIconContainer = document.getElementById('cart-icon-bubble');
      if (cartIconContainer) {
        // Check if there are any SVG icons
        const hasSvg = cartIconContainer.querySelector('svg, use, symbol');
        const iconContainer = cartIconContainer.querySelector('.header-cart-icon');
        const hasImg = iconContainer && iconContainer.querySelector('img');
        
        if (hasSvg || !iconContainer || !hasImg) {
          preserveCartIcon();
        }
      }
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
